import styled from 'styled-components';
import { MessageBar } from '@fluentui/react-message-bar';
export const MessageBarContainer = styled(MessageBar)<{
  overlay: boolean;
  isCentered: boolean;
}>`
  position: ${({ overlay }) => (overlay ? 'absolute' : 'relative')};
  width: ${({ overlay }) => (overlay ? '100%' : 'auto')};
  z-index: ${({ overlay }) => (overlay ? '10' : '0')};

  ${({ isCentered }) =>
    isCentered &&
    `
      display: flex;
      justify-content: center;
  `}
`;
